module.exports = __webpack_public_path__ + "img/schnittkante_reinorange_ral2004.73372420.jpg";